class Certificate {
    constructor({
        awardedTo = null,
        awardedFor = null,
        competitionDate = null,
        rank = null,
        trophyName = null,
        certificateLayout = null,
        certificateType = "NORMAL"
    } = {}) {
        this.awardedTo = awardedTo;
        this.awardedFor = awardedFor;
        this.competitionDate = competitionDate;
        this.rank = rank;
        this.trophyName = trophyName;
        this.certificateLayout = certificateLayout;
        this.certificateType = certificateType;
    }

    toJSON() {
        return {
            name: this.awardedTo,
            rank: this.rank,
            competition_date: this.competitionDate,
            award_description: this.awardedFor,
            certificate_type: this.certificateType,
            trophy_name: this.trophyName
        };
    }

}

export default Certificate;
